import app from './app.js';
app.update(state => state);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/